var React = require('react');

function ArrowDownRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 19.8724L0 2.04425L6 2.04425L6 19.8724C6 22.6338 8.23858 24.8724 11 24.8724L60 24.8724V30.8724L11 30.8724C4.92487 30.8724 0 25.9475 0 19.8724Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M55.9014 27.8724L33.7578 4.08851L38.1492 0L62.1961 25.8281V29.9166L38.1492 55.7448L33.7578 51.6562L55.9014 27.8724Z","fill":"white","key":1})]);
}

ArrowDownRightInline.defaultProps = {"width":"63","height":"56","viewBox":"0 0 63 56","fill":"none"};

module.exports = ArrowDownRightInline;

ArrowDownRightInline.default = ArrowDownRightInline;
